import { ArticleHeading2, UIText3 } from '@cian/ui-kit';

import * as styles from './Price.css';

export interface IPriceProps {
  terms: (string | null)[];
}

export function Price({ terms }: IPriceProps) {
  if (!terms) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {terms.map((term, index) => {
        if (term && index === 0) {
          return <ArticleHeading2 key={index}>{term}</ArticleHeading2>;
        }
        if (term) {
          return (
            <UIText3 key={index} color="text-secondary-default">
              {term}
            </UIText3>
          );
        }

        return null;
      })}
    </div>
  );
}
